import {component, EntityData, field, identifier} from "@fedeltapointofsale/data-client";
import {AccountChargeData} from "./account-charge.data";

export class PaymentChargeLinkData extends EntityData<PaymentChargeLinkData> {

    @identifier linkId: number;
    @component charge: AccountChargeData;

    @field amtUsed: number;
    @field creditAmt: number;


}
